import React, { useState, useRef, useEffect } from "react";
import {
  SliderInput,
  SliderTrack,
  SliderTrackHighlight,
  SliderHandle
} from "@reach/slider";
import _ from "lodash";
import "@reach/slider/styles.css";
import padStart from "lodash.padstart";
import LogsService from "../../utils/logs";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getContentDetailsOnClick } from '../../utils/utility'
function time(seconds) {
  const minutes = parseInt(seconds / 60);
  const leftSeconds = seconds - minutes * 60;
  return `${padStart(minutes, 2, "0")}:${padStart(leftSeconds, 2, "0")}`;
}


const AudioPlayer = ({ url, canProceed, post, contentId, title, loadStatus }) => {
  const audioRef = useRef();
  const [state, setState] = useState({
    isPlaying: false,
    currentTime: 0,
    duration: 0,
    volume: 0,
    showVolumeBar: false
  });
  const [audioPercentage] = useState({
    is25PercentAudioCompleted: false,
    is50PercentAudioCompleted: false,
    is75PercentAudioCompleted: false,
    isUserPlayFirstTime: true
  })
  const [audioTotalDuration, setAudioTotalDuration] = useState("00:00");
  useEffect(() => {
    let audio = document.getElementById(post.id);
    audio.onloadedmetadata = function () {
      let audioDuration = formatSecondsAsTime(Math.floor(audio.duration).toString()) || audioTotalDuration;
      setAudioTotalDuration(audioDuration);
    };
  }, [audioTotalDuration]);
  const getAudioAdobeObject = ({ audioAction, aTime }) => {
    return {
      event: "audio",
      eventInfo: "audio",
      action: audioAction,
      audio: {
        audioID: post.id,
        audioTitle: post.title,
        audioMetaTags: "",
        audioTime: aTime,
      },
    };
  };

  const handleDurationChange = e => {
    if (!canProceed()) {
      return;
    }
    const duration = parseInt(e.target.duration, 10);
    const volume = e.target.volume * 100;
    setState({ ...state, duration, volume });
  };

  const handleTimeUpdate = e => {
    if (!canProceed() || !state.isPlaying) {
      return;
    }
    const currentTime = parseInt(e.target.currentTime, 10);
    setState({ ...state, currentTime });
  };

  const handlePlay = async () => {
    if (!canProceed()) {
      return;
    }
    const sounds = document.getElementsByTagName("timeupdate");
    if (sounds && sounds.length > 0) {
      _.forEach(sounds, sound => {
        try {
          sound.pause();
        } catch (e) { }
      });
    }

    audioRef.current.play();
    await LogsService.logAudioClick(url.split("/").pop());
    setState({ ...state, isPlaying: true });

  };

  const handlePlause = () => {
    if (!canProceed()) {
      return;
    }
    audioRef.current.pause();
    setState({ ...state, isPlaying: false });
  };

  const toggleShowVolumneBar = () =>
    setState({ ...state, showVolumeBar: !state.showVolumeBar });

  const handleSeek = currentTime => {
    if (!canProceed()) {
      return;
    }
    audioRef.current.currentTime = currentTime;
    setState({ ...state, currentTime });
  };

  const handleChangeVolume = volume => {
    if (!canProceed()) {
      return;
    }
    audioRef.current.volume = volume / 100;
    setState({ ...state, volume });
  };

  let aId;
  let onAudioData = {};

  const formatSecondsAsTime = (secs) => {
    let hr = Math.floor(secs / 3600);
    let min = Math.floor((secs - hr * 3600) / 60);
    let sec = Math.floor(secs - hr * 3600 - min * 60);
    if (min < 10) {
      min = "0" + min;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }
    return min + ":" + sec;
  };
  const audioPlayed = () => {
    aId = document.getElementById(post.id);
    /* code starts here for play button */
    if (audioPercentage.isUserPlayFirstTime) {
      onAudioData = getAudioAdobeObject({
        audioAction: "audio-play",
        aTime: aId.currentTime.toString(),
      });
      pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
      getContentDetailsOnClick(post, 'audio-play', 'card-content')
      audioPercentage.isUserPlayFirstTime = false;
    }
    /* code ends here for play button */
    aId.addEventListener("timeupdate", function () {
      if (parseInt(this.currentTime) === parseInt(this.duration * 0.25)) {
        if (!audioPercentage.is25PercentAudioCompleted) {
          onAudioData = getAudioAdobeObject({
            audioAction: "audio-25",
            aTime: this.currentTime.toFixed(2).toString(),
          });
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
          audioPercentage.is25PercentAudioCompleted = true;
        }
      }

      if (parseInt(this.currentTime) === parseInt(this.duration * 0.5)) {
        if (!audioPercentage.is50PercentAudioCompleted) {
          onAudioData = getAudioAdobeObject({
            audioAction: "audio-50",
            aTime: this.currentTime.toFixed(2).toString(),
          });
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
          audioPercentage.is50PercentAudioCompleted = true;
        }
      }

      if (parseInt(this.currentTime) === parseInt(this.duration * 0.75)) {
        if (!audioPercentage.is75PercentAudioCompleted) {
          onAudioData = getAudioAdobeObject({
            audioAction: "audio-75",
            aTime: this.currentTime.toFixed(2).toString(),
          });
          pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
          audioPercentage.is75PercentAudioCompleted = true;
        }
      }
    });

  };
  const audioPause = () => {
    aId = document.getElementById(post.id);
    if (audioRef.current.duration > audioRef.current.currentTime) {
      onAudioData = getAudioAdobeObject({
        audioAction: "audio-pause",
        aTime: audioRef.current.currentTime.toFixed(2).toString(),
      });
      pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
      getContentDetailsOnClick(post, 'audio-pause', 'card-content')

    }
  };

  const audioEnded = () => {
    audioPercentage.isUserPlayFirstTime = true;
    audioPercentage.is25PercentAudioCompleted = false;
    audioPercentage.is50PercentAudioCompleted = false;
    audioPercentage.is75PercentAudioCompleted = false;
    onAudioData = getAudioAdobeObject({
      audioAction: "audio-complete",
      aTime: audioRef.current.currentTime.toFixed(2).toString(),
    });
    pushDatatoAdobeLayer({ pageData: false, adobePushTracking: false, onAudioData });
  };
  return (
    <div className="w-full my-3 px-2" adoberegion="card-content">
      <audio
        id={post.id}
        ref={audioRef}
        onPlay={audioPlayed}
        onPause={audioPause}
        onEnded={audioEnded}
        onDurationChange={handleDurationChange}
        onTimeUpdate={handleTimeUpdate}
      >
        <source src={url} type="audio/mpeg" />
      </audio>

      <div className="flex items-center text-xl">
        {!state.isPlaying && (
          <div
            className="cursor-pointer"
            style={{ padding: "0 10px" }}
            onClick={handlePlay}
          >
            <i className="fas fa-play" />
          </div>
        )}
        {state.isPlaying && (
          <div
            className="cursor-pointer"
            style={{ padding: "0 10px" }}
            onClick={handlePlause}
          >
            <i className="fas fa-pause" />
          </div>
        )}

        <div
          style={{ padding: "0 10px" }}
          className="relative cursor-pointer"
          onClick={toggleShowVolumneBar}
        >
          {state.volume >= 50 && <i className="fas fa-volume-up" />}
          {state.volume > 0 && state.volume < 50 && (
            <i className="fas fa-volume-down" />
          )}
          {state.volume === 0 && <i className="fas fa-volume-mute" />}
          {state.showVolumeBar && (
            <div
              className="absolute bg-gray-500 rounded-lg pl-1 pr-2 py-3"
              style={{ bottom: "25px" }}
            >
              <SliderInput
                value={state.volume}
                max={100}
                orientation="vertical"
                style={{ padding: "4px", height: "100px" }}
                onChange={handleChangeVolume}
              >
                <SliderTrack>
                  <SliderTrackHighlight />
                  <SliderHandle />
                </SliderTrack>
              </SliderInput>
            </div>
          )}
        </div>

        <div style={{ padding: "0 10px" }}>
          {time(state.currentTime)} / {time(state.duration)}
        </div>

        <div className="flex-1">
          <SliderInput
            value={state.currentTime}
            max={state.duration}
            onChange={handleSeek}
            style={{ padding: "25px 15px", width: "100%" }}
          >
            <SliderTrack style={{ background: "#ccc" }}>
              <SliderTrackHighlight style={{ background: "#3498db" }} />
              <SliderHandle
                style={{
                  backgroundColor: "#fff",
                  border: 0,
                  boxShadow: "0.5px 0.5px 2px 1px rgba(0, 0, 0, .32)"
                }}
              />
            </SliderTrack>
          </SliderInput>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
